<p-dialog header="Transfer Funds" [(visible)]="display" [modal]="true" [style]="{width: '60vw'}" [blockScroll]="true" (onHide)="onClose('cancel')">
    <ng-template pTemplate="header">
        <div class="p-d-flex p-jc-between w-100">
            <h5 class="p-mb-0">{{fundTransferHeader}}</h5>
            <div class="p-field p-grid" *ngIf="statementMessage">
                <strong [ngClass]="'status-open'">{{statementMessage}}</strong>
            </div>
            <span *ngIf="dialogType === 'VIEW' && !isVoided && isEditableViewDialog"  class="btnBars" (click)="viewToEditFundTransfer()">
                <i class="pi pi-pencil"></i>
            </span>
        </div>
    </ng-template>
    <form [formGroup]="transferFundForm">
        <div class="card">
            <div class="p-grid">
                <div class="p-col-12 p-md-8">
                    <label>Transfer Funds From <span style="color: red;">*</span>
                    <span class="p-ml-3">
                        (Acount Balance: {{currencySymbol}})
                        <strong style="color: red">{{fromAccountEndingBalance | customNumberFormat: fractionDigits}}</strong>
                    </span>
                </label>
                    <!-- <p-dropdown placeholder="Select a Bank" optionLabel="name" [showClear]="true" appendTo="body" [options]="fromAccounts" optionValue="id" formControlName="fromFinancialAccountId" (onChange)="onChangeFromAccount($event)"></p-dropdown> -->
                    
                    <liono-treeSelect class="border-bottom-input" [options]="fromAccounts" appendTo="body" placeholder="Select" formControlName="fromFinancialAccountId" 
                        display="comma" [metaKeySelection]="false" selectionMode="single" (onNodeSelect)="onChangeFromAccount($event)">
                    </liono-treeSelect>
                </div>
                <div class="p-col-12 p-md-4">
                    <label>Date <span style="color: red;">*</span></label>
                    <p-calendar [showIcon]="true" inputId="icon" appendTo="body" formControlName="transferDate"></p-calendar>
                </div>
            </div>
            <div class="p-grid">
                <div class="p-col-12 p-md-8">
                    <label>Transfer Funds To <span style="color: red;">*</span></label>
                    <!-- <p-dropdown placeholder="Select a Bank" optionLabel="name" [showClear]="true" appendTo="body" [options]="toAccounts" optionValue="id" formControlName="toFinancialAccountId"></p-dropdown> -->
                
                    <liono-treeSelect class="border-bottom-input" [options]="toAccounts" appendTo="body" placeholder="Select" formControlName="toFinancialAccountId" 
                        display="comma" [metaKeySelection]="false" selectionMode="single">
                    </liono-treeSelect>
                </div>
                <div class="p-col-12 p-md-4">
                    <label>Transfer Amount <span style="color: red;">*</span></label>
                    <p-inputNumber inputId="locale-user" [minFractionDigits]="fractionDigits" [maxFractionDigits]="fractionDigits" formControlName="transferAmount"></p-inputNumber>
                </div>
            </div>
            <div class="p-grid">
                <div class="p-col-12">
                    <label>Memo</label>
                    <input type="text" pInputText formControlName="memo">
                </div>
            </div>
            <div class="p-grid" *ngIf="isAllowPostingPeriod">
                <div class="p-col-6">
                    <label>Posting Period:<span style="color: red">*</span></label>
                    <!-- {postingDate: transferFundDetails?.postingDate,postingMonth: transferFundDetails?.postingMonth,postingYear: transferFundDetails?.postingYear} -->
                    <app-posting-period-selector 
                        [transactionDate]="transferFundForm?.get('transferDate')?.value" 
                        [isViewMode]="dialogType === 'VIEW'" 
                        [selectedPostingPeriod]="currentPostingPeriodInfo" [moduleName]="'FundTransfer'"
                        (postingInfoChange)="onPostingInfoChange($event)">
                    </app-posting-period-selector>
                </div>
            </div>
        </div>
    </form>
    <ng-template pTemplate="footer">
        <button *ngIf="dialogType == 'VIEW' && isShowVoidDelete" type="button" pButton label="Void" [disabled]="isVoided" (click)="voidOrDelete(true)" class="p-mr-2"></button>
        <p-button *ngIf="dialogType == 'VIEW' && isShowVoidDelete" [label]="'Delete'" styleClass="p-button-danger" (click)="voidOrDelete(false)" class="p-mr-2"></p-button>
        <p-button (click)="onClose('cancel')" label="Cancel" styleClass="p-button-secondary"></p-button>
        <p-button *ngIf="dialogType != 'VIEW'" (click)="save()" label="Save" [disabled]="(isAllowPostingPeriod && !updatedPostingPeriodInfo?.postingDate) ||!transferFundForm?.valid || !!statementMessage"></p-button>
    </ng-template>
</p-dialog>

<!-- closing statement -->
<ng-container *ngIf="display">
    <app-closing-statement-validation
        [isClosingDate]="isAllowPostingPeriod ? (updatedPostingPeriodInfo?.postingDate ?? currentPostingPeriodInfo?.postingDate ?? null) : transferFundForm?.controls?.transferDate.value" 
        [moduleName]="'FundTransfer'" (isClosingStatementDate)="isClosingStatementDate($event)">
    </app-closing-statement-validation>
</ng-container>